import styled, { css } from 'styled-components';

import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { BREAKPOINTS } from '~/src/components/BlockInternet/constants';

type TImgBlock = {
    background?: string,
    imgFirst?: string,
    imgSecond?: string,
    imgThird?: string,
}

export const MiniBannersInternetContainer = styled.div`
    width: auto;
    box-sizing: content-box;
    margin: 32px 0;
`;

export const MiniBannersInternetBlock = styled.div`
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 32px;

    @media (max-width: ${BREAKPOINTS.mobile}) {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
    }
`;

export const ImgBlock = styled.div<TImgBlock>`
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
    border-radius: ${BorderRadius.OuterBlockRadius};
    ${(props) => props.background && css`
    background: ${props.background};
    background-repeat: no-repeat;
    height: 168px;
    overflow: hidden;

    @media (max-width: ${BREAKPOINTS.laptop}) {
        flex-direction: column;
        height: 347px;
        width: auto;
    }
`};
`;

export const ImgContainer = styled.div`
    position: relative;
    width: 40%;
    height: 100%;

    @media (max-width: ${BREAKPOINTS.desktop}) {
        width: 30%;
    }

    @media (max-width: ${BREAKPOINTS.laptop}) {
        width: 100%;
        height: 100%;
    }
`;

export const AbsoluteImgOne = styled.div<TImgBlock>`
    position: absolute;
    ${(props) => props.imgFirst && css`
    background-image: url('${props.imgFirst}');
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    top: 90px;
    left: 22px;

    @media (max-width: ${BREAKPOINTS.desktop}) {
        left: 10px;
    }

    @media (max-width: ${BREAKPOINTS.laptop}) {
        left: 125px;
        top: 70px;
    }
`};
`;

export const AbsoluteImgTwo = styled.div<TImgBlock>`
    position: absolute;
    ${(props) => props.imgSecond && css`
    background-image: url('${props.imgSecond}');
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    border-radius: 16px;
    filter: blur(3px);
`};
`;

export const AbsoluteImgThree = styled.div<TImgBlock>`
    position: absolute;
    ${(props) => props.imgThird && css`
    background-image: url('${props.imgThird}');
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    top: 45px;
    left: 90px;
    filter: blur(2px);

    @media (max-width: ${BREAKPOINTS.desktop}) {
        top: -5px;
        left: 225px;
    }

    @media (max-width: ${BREAKPOINTS.laptop}) {
        top: 15px;
        left: 105px;
    }
`};
`;

export const TextBlock = styled.div`
    width: 60%;
    margin: 16px 12px;

    @media (max-width: ${BREAKPOINTS.desktop}) {
        width: 86%;
    }

    @media (max-width: ${BREAKPOINTS.laptop}) {
        margin: 0;
        margin-top: auto;
        flex: 0 1 1%;
        height: 100%;
        width: 100%;
        padding: 0 20px 24px;
    }

    @media (max-width: ${BREAKPOINTS.mobile}) {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
    }
`;

export const Title = styled.div`
    margin: 8px 0px;
    ${FONTS.H4};
    white-space: pre-line;
`;

export const SubText = styled.div`
    ${FONTS.XS};
`;
